import { IdentityProviderDetails } from "@idw-types/data/identity-providers";

export const initialIdentityProviderDetails = (organizationId: string): IdentityProviderDetails => {
    return {
        companyIDPInfo: {
            companyIDPInfoParams: [],
            companyIDPAttributeMaps: [],
            status: "active",
            scope: "openid profile",
            companyID: null,
            idpRedirectURL: null,
            userCredentialField: "sub",
            tokenAuthScheme: "REQUESTPARAMS",
            authURL: null,
            wellKnownURL: null,
            clientSecret: null,
            tokenURL: null,
            userInfoURL: null,
            jwksURL: null,
            clientID: null,
            id: null,
        },
        name: "New Identity Provider",
        protocol: "oidc",
        code: null,
        category: "enterprise",
        companyID: organizationId,
        loa: "1",
        classificationID: "3",
        id: null,
        permissions: {
            canCancel: true,
            canDeploy: true,
            canModify: true,
            canReview: true,
            canSubmit: true,
            canView: true
        }
    }
};
